module.exports = __webpack_public_path__ + "static/media/bruno-neves.995aff05.png";